module.exports = __webpack_public_path__ + "img/spend.c016bc62.png";